import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PassWithData from './PassWithData';
import { useDidMount } from '../../../utils/hooks';

const Pass = ({ registerForm, setPass, withPin = true }) => {
    const [clearText, setClearText] = useState(false);

    const validator = (value) => (value ? true : 'pass');

    useDidMount(() => {
        if (registerForm) {
            registerForm({
                pass: validator,
            });
        }
    });

    const clearTextSwitch = () => {
        setClearText(!clearText);
    };

    return (
        <PassWithData
            validator={validator}
            setPass={setPass}
            clearText={clearText}
            clearTextSwitch={clearTextSwitch}
            formNames
            withPin={withPin}
        />
    );
};

Pass.propTypes = {
    registerForm: PropTypes.func,
    setPass: PropTypes.func.isRequired,
};

export default Pass;
